import { Controller } from "@hotwired/stimulus"

// App Access & Roles (admin/users _app_access partial): enables a
// department's role select while its access toggle is on, disables it (and
// dims it) while off. Replaces an inline DOMContentLoaded script that never
// ran after a Turbo navigation, which left the role select stuck disabled
// when access was toggled on (owner report, v194).
//
// It also keeps the row's On/Off word in step with the switch, and shows the
// Intern Team box's tick for a department only while that department's
// access is on with an Intern or Default role (owner directive 2026-10-08),
// hiding the box when no tick applies.
export default class extends Controller {
  static targets = ["accessToggle", "roleSelect", "accessState", "internTeam", "internTeamTick"]

  connect() {
    this.refreshTeams()
  }

  toggle(event) {
    const app = event.target.dataset.app
    const state = this.accessStateTargets.find((el) => el.dataset.app === app)
    if (state) state.textContent = event.target.checked ? "On" : "Off"
    const select = this.roleSelectTargets.find((el) => el.dataset.app === app)
    if (select) {
      select.disabled = !event.target.checked
      select.classList.toggle("opacity-50", !event.target.checked)
    }
    this.refreshTeams()
  }

  refreshTeams() {
    if (!this.hasInternTeamTarget) return
    let any = false
    this.internTeamTickTargets.forEach((tick) => {
      const app = tick.dataset.app
      const toggle = this.accessToggleTargets.find((el) => el.dataset.app === app)
      const select = this.roleSelectTargets.find((el) => el.dataset.app === app)
      // A row this editor cannot change has no switch: keep what the server
      // worked out from the saved access and role.
      tick.hidden = toggle ? !(toggle.checked && (!select || ["", "intern"].includes(select.value)))
                           : tick.dataset.offerable !== "1"
      if (!tick.hidden) any = true
    })
    this.internTeamTarget.hidden = !any
  }
}
